(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["animated-testimonials"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('image-arc-carousel')) {
    customElements.define('image-arc-carousel', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.image-arc__slide')];
        this.dots = [...this.querySelectorAll('[data-index]')];
        this.index = 0;
        this.paused = false;
        this.hovered = false;
        this.focused = false;
        this.abort = new AbortController();

        const options = { signal: this.abort.signal };
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');

        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button) return;

          if (button.dataset.index !== undefined) {
            this.go(Number(button.dataset.index));
          }

          if (button.dataset.action === 'next') this.go(this.index + 1);
          if (button.dataset.action === 'prev') this.go(this.index - 1);

          if (button.dataset.action === 'pause') {
            this.paused = !this.paused;
            button.setAttribute('aria-pressed', String(this.paused));
            button.textContent = this.paused ? '▶' : '❚❚';
          }

          this.schedule();
        }, options);

        this.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }, options);

        this.addEventListener('pointerenter', () => {
          this.hovered = true;
          this.schedule();
        }, options);

        this.addEventListener('pointerleave', () => {
          this.hovered = false;
          this.schedule();
        }, options);

        this.addEventListener('focusin', () => {
          this.focused = true;
          this.schedule();
        }, options);

        this.addEventListener('focusout', event => {
          this.focused = this.contains(event.relatedTarget);
          this.schedule();
        }, options);

        const viewport = this.querySelector('.image-arc__viewport');

        viewport.addEventListener('pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;

          this.start = {
            x: event.clientX,
            y: event.clientY,
            id: event.pointerId
          };

          viewport.setPointerCapture(event.pointerId);
        }, options);

        viewport.addEventListener('pointerup', event => {
          if (!this.start || this.start.id !== event.pointerId) return;

          const dx = event.clientX - this.start.x;
          const dy = event.clientY - this.start.y;
          this.start = null;

          if (Math.abs(dx) > 35 && Math.abs(dx) > Math.abs(dy)) {
            this.go(this.index + (dx < 0 ? 1 : -1));
          }
        }, options);

        viewport.addEventListener('pointercancel', () => {
          this.start = null;
        }, options);

        document.addEventListener(
          'visibilitychange',
          () => this.schedule(),
          options
        );

        this.motion.addEventListener(
          'change',
          () => this.schedule(),
          options
        );

        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(
            slide => slide.dataset.blockId === event.detail.blockId
          );

          if (index < 0) return;

          this.paused = true;
          const button = this.querySelector('[data-action="pause"]');

          if (button) {
            button.setAttribute('aria-pressed', 'true');
            button.textContent = '▶';
          }

          this.go(index);
        }, options);

        this.resize = new ResizeObserver(() => this.render());
        this.resize.observe(this);
        this.render();
        this.schedule();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        this.abort?.abort();
        this.resize?.disconnect();
      }

      go(index) {
        if (!this.slides.length) return;

        this.index = (index + this.slides.length) % this.slides.length;
        this.render();
        this.schedule();
      }

      render() {
        const total = this.slides.length;
        if (!total) return;

        const width = this.slides[0].getBoundingClientRect().width;
        const baseWidth = this.slides[0].offsetWidth || width;
        const gap = parseFloat(
          getComputedStyle(this).getPropertyValue('--arc-gap')
        ) || 0;

        const angle = Number(this.dataset.angle);

        this.slides.forEach((slide, index) => {
          let offset = (index - this.index + total) % total;
          if (offset > total / 2) offset -= total;

          const distance = Math.abs(offset);

          slide.style.transform =
            `translate3d(${offset * (baseWidth + gap)}px, 0, ${-distance * 60}px) ` +
            `rotateY(${-Math.sign(offset) * Math.min(distance, 2) * angle}deg)`;

          slide.style.zIndex = String(total - distance);

          const hidden =
            distance * (baseWidth + gap) >
            this.clientWidth / 2 + baseWidth / 2;

          slide.style.opacity = hidden ? '0' : '1';
          slide.setAttribute('aria-hidden', String(hidden));
        });

        this.dots.forEach((dot, index) => {
          if (index === this.index) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      schedule() {
        clearTimeout(this.timer);

        if (
          this.dataset.autoplay !== 'true' ||
          this.slides.length < 2 ||
          this.paused ||
          this.hovered ||
          this.focused ||
          this.motion.matches ||
          document.hidden ||
          window.Shopify?.designMode
        ) return;

        this.timer = setTimeout(
          () => this.go(this.index + 1),
          Number(this.dataset.delay)
        );
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
